/* eslint-disable */

'use strict'

const VIVA_COOKIE_NAME = 'viva-cookie'

function hasVivaCookie () {
    let aout = localStorage && (localStorage[VIVA_COOKIE_NAME] !== undefined)
    // console.log(`hasVivaCookie   aout: ${aout}  localStorage: ${localStorage} cookie: ${localStorage[VIVA_COOKIE_NAME]} `)
    return aout
}
function setVivaCookie () {
    if (localStorage) {
        localStorage[VIVA_COOKIE_NAME] = (new Date).toString()  // set to current date.
    }
}

/* Escape newlines with <br> - also a filter*/
function nl2br(val) {
    let aout = (val) ? val.replace(/\r\n/gi, '<br>') : ''
    return aout;
}

// Date object
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse

// The "pretty" functions are used to format date values for display.
// Returns blank if invalid data.  Coding originally checked for
// specific data validity, but seemed quicker to wrap in try blocks
// and bail on any errors.
function prettyDateTime(dateStr) {
    let aout = ''
    try {
        let d = new Date(dateStr)
        aout = `${prettyDate(d)} at ${prettyTime(d)} (local)`
    }
    catch(e) {}
    return aout
}

// Returns: Tue Jul 29, 2025
function prettyDate(arg) {
    let aout = ''
    try {
        let d = (isString(arg)) ? new Date(arg) : arg
        aout = `${getDayShort(d.getDay())} ${getMonthShort(d.getMonth())} ${d.getDate()}, ${d.getFullYear()}`
    } catch(e) {}
    return aout
}

// Returns: Jul 29, 2025
function prettyDateMin(arg) {
    let aout = ''
    try {
        let d = (isString(arg)) ? new Date(arg) : arg
        aout = `${getMonthShort(d.getMonth())} ${d.getDate()}, ${d.getFullYear()}`
    } catch(e) {}
    return aout
}

function prettyTime(arg) {
    let aout = ''
    try {
        let d = (isString(arg)) ? new Date(arg) : arg
        let hr = parseInt(d.getHours())
        let mn = ('0'+d.getMinutes()).slice(-2)
        aout = `${(hr > 12) ? hr-12: hr}:${mn} ${(hr >= 12) ? 'PM' : 'AM'}`
    }
    catch(e) {}
    return aout
}

function getDayShort(day) {
    let days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
    return days[day]
}

function getMonthShort(month) {
    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    return months[month]
}

function getDateTimeZ(d) {   // d is a date object
    // Takes date object and converts to string YYYYMMNNTHHMMSSZ   <-- T and Z are literals, SS must be present
    var aout = ''
    try {
      aout = d.getFullYear()
        + ('0' + (d.getMonth() + 1)).slice(-2)
        + ('0' + d.getDate()).slice(-2)
        + 'T'
        + ('0' + d.getHours()).slice(-2)
        + ('0' + d.getMinutes()).slice(-2)
        + '00Z'
    } catch(e) {}
    return aout
  }

function isString(arg) {
    return (typeof arg === 'string')
}

const SECONDS_IN_MINUTE = 60
const MINUTES_IN_HOUR = 60
const SECONDS_IN_HOUR = 3600  // 3600 seconds per hour
const SECONDS_IN_DAY = 24*SECONDS_IN_HOUR

function prettySeconds(durationSeconds) {
    // console.log('prettySeconds')
    let aout = "00:00:00"
    try {
        let secs = parseInt(durationSeconds)
        let hours = Math.floor(secs/SECONDS_IN_HOUR)
        let minutes = Math.floor( (secs % SECONDS_IN_HOUR)/MINUTES_IN_HOUR )
        let seconds = (secs % SECONDS_IN_HOUR) % SECONDS_IN_MINUTE
        aout = (hours > 0)
            ? `${twoDigits(hours)}:${twoDigits(minutes)}:${twoDigits(seconds)}`
            : `${twoDigits(minutes)}:${twoDigits(seconds)}`
    }
    catch (e) { console.log(e) }
    return aout
}

/* Converts 1234 to 1,234 in locale-sensitive way. */
function prettyNumber(num) {
    let aout = 0
    try {
        aout = num.toLocaleString()
    }
    catch (e) { console.log(e) }
    return aout
}

function prettyCountdown(deltaSeconds) {
    let aout = `ERROR: ${deltaSeconds}`
    try {
        let secs = parseInt(deltaSeconds)
        if (secs <= 0) {
            aout = 'Webinar in Progress...'
        }
        else {
            // console.log(`prettyCountdown secs ${secs}`)
            let days = Math.floor(secs/SECONDS_IN_DAY)  // 24*3600 seconds in day
            let hours = Math.floor((secs-(days*SECONDS_IN_DAY))/SECONDS_IN_HOUR)  // 3600 seconds per hour
            let minutes = Math.floor( (secs % SECONDS_IN_HOUR)/SECONDS_IN_MINUTE )
            let seconds = (secs % SECONDS_IN_HOUR) % SECONDS_IN_MINUTE
            aout = ''
            if (days > 0) {
                aout = aout.concat(`${days} Day${plural(days,'s')}, `)
            }
            if (hours > 0) {
                aout = aout.concat(`${hours} Hour${plural(hours,'s')}`)
            }
            if (aout !== '' || minutes > 0) {
                if (hours > 0) aout = aout.concat(' and ')
                aout = aout.concat(`${minutes} Minute${plural(minutes,'s')}`)
            }
            // if (aout === '' && seconds > 0) {
            if (days === 0 && hours === 0 && minutes < 5 && seconds > 0) {
                if (minutes > 0) aout = aout.concat(' and ')
                aout = aout.concat(`${seconds} Second${plural(seconds,'s')}`)
            }
            if (aout === '') {
                aout = 'Webinar in Progress...'
            }
        }
    }
    catch (e) { console.log(e) }
    // console.log(`prettyCountdown: ${aout}`)
    return aout
}

// Given integer val returns 2 digit string.  Useful for HH:MM:SS
function twoDigits(val) {
    return ('00'+val.toString()).slice(-2)
}

// Returns suffix if integer val is not equal to 1.
function plural(val, suffix) {
    return (val === 1) ? '' : suffix
}

// Extracts youtube code from these templates:
// https://www.youtube.com/watch?v=SR4Eec9F89M&list=RDmg7netw1JuM
// https://youtu.be/SR4Eec9F89M?list=RDmg7netw1JuM
// Extracts code:  SR4Eec9F89M
function getYoutubeCode( url ) {
    var code = '';
    if (typeof url === 'string') {
        var arr = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
        code = arr[1];
        // console.log( `getYoutubeCode: ${code}`);
    }
    return code;
}

// Builds YouTube Url from code.
// Suitable for b-embed and vue-plyr
function getYoutubeUrl( videoId, autoplay ) {
    // console.log( `getYoutubeUrl videoId: ${videoId}`);
    var url = `https://www.youtube.com/embed/${videoId}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1&origin=${getHost()}`
    url += (autoplay) ? '&autoplay=1' : ''
    // console.log( `utils getYoutubeUrl: ${url}`);
    return url
 }

// Returns http://domain or https://domain or https://domain:8080
function getHost() {
    // includes port if non-standard
    let host = `${window.location.protocol}//${window.location.host}`
    // console.log(`host: ${host}`)
    return host
}

/* Parses val, returns defaultVal if val cannot be parsed. */
function safeParseInt(val, defaultVal) {
    const parsed = parseInt(val)
    let aout = ((defaultVal) ? defaultVal : 0)
    if (!isNaN(parsed)) { aout = parsed }
    return aout;
}

// Processes a search string for safety.
const MAX_SEARCH_LENGTH = 30
function safeSearch(q) {
    let aout = null
    if (isString(q) && q.length > 0) {
        q = q.replace("'","")
        if (q.length > 2) {
            aout = q.slice(0,MAX_SEARCH_LENGTH)
        }
        else {
            // safe 2 letter words.
            let arr = ['3m']
            if (arr.includes(q.toLowerCase())) {
                aout = q
            }
        }
    }
    return aout
}

function ifNull(exp, value) {
    return ( exp != null ) ? exp : value
}

// returns local, test, prod
// forced optional setting overrides hostVal (created using location.host)
// hostVal may have port number; eg domain:port, localhost:8080
function getRunMode(hostVal, hostMap, forcedMode) {
    let aout = hostMap.defaultRunMode
    if (forcedMode && forcedMode.length !== 0) {
        aout = forcedMode  //
    }
    else if (hostVal && hostVal.length !== 0) {
        let host = hostVal.split(':')[0].toLowerCase()
        // Wanted to use Object.keys(hostMap.sites) but got error.
        // In array put prod first for faster production search.
        for(let siteName of ['prod','test','local'] ) {
            if (hostMap.sites[siteName].hosts.includes(host)) {
                aout = siteName
                break
            }
        }
    }
    return aout
}

// Helper function that assists injecting ads into a set of items.
// itemCnt: number of main list items, such as list of classes or podcasts
// adCnt: number of ads to be injected
// adStartPos: 1-based index of ad placement among "items"
// Resultant array is of length itemCnt.  The value of an array element
// is either -1 or the index(0 to adCnt-1) of an ad to display.
function getAdIndexArray( itemCnt, adCnt, adStartPos, adInterval ) {
    let arr = new Array()
    let adCurPos = adStartPos
    let adCurIx = 0   // index of ad.
    for(let ix=0; ix <= itemCnt; ix++) {
        // console.log(`processing ${ix} adCurPos: ${adCurPos}  len: ${arr.length}`)
        if ( adCurPos == ix && adCurIx < adCnt ) {
            arr[ix] = adCurIx
            adCurIx++
            adCurPos += adInterval
        }
        else {
            arr[ix] = -1
        }
    }
    return arr
}

// uses runMode to extract baseUrl from hostMap
function getApiBaseUrl(runModeArg, hostMap) {
    let runMode = runModeArg || hostMap.defaultRunMode
    let baseUrl = hostMap.sites[runMode].api
    return baseUrl
}

// The first element in a b-form-select list.
function initSelectArray() {
    return {value: undefined, text: '-- select one --'}
}

// data: array of values.
// Returns [{data: data[ix], value: data[ix]}]
function prepSelectArray(data) {
    var arr = []
    if (data) {
        for( var ix=0; ix < data.length; ix++) {
            arr.push({value: data[ix], text: data[ix]})
        }
    }
    return arr
}

function isApple() { return (/iPhone|iPod|iPad/i).test(navigator.userAgent) }
function isAndroid() { return (/Android/i).test(navigator.userAgent) }
function isMobile() { return this.isApple() || this.isAndroid() }
function isDesktop() { return !this.isMobile() }

// return the first few words of str that fit in maxlen
function leadingWords (str, maxlen) {
  var aout = "";

  if (str.length > maxlen) {
    var words = str.split(' ');
    var idx = 0;
    while (aout.length <= maxlen - 3) {
      aout += ' ' + words[idx];
      idx++;
    }
    aout = aout.trim() + "...";
  }
  else {
    aout = str;
  }

  return aout;
}

/* Define module */
let utils = {
    nl2br: nl2br,
    prettyDateTime: prettyDateTime,
    prettyDate: prettyDate,
    prettyDateMin: prettyDateMin,
    prettyTime: prettyTime,
    prettySeconds: prettySeconds,
    prettyNumber: prettyNumber,
    prettyCountdown: prettyCountdown,
    getDateTimeZ: getDateTimeZ,
    isString: isString,
    getYoutubeCode: getYoutubeCode,
    getYoutubeUrl: getYoutubeUrl,
    safeParseInt: safeParseInt,
    safeSearch: safeSearch,
    ifNull: ifNull,
    getRunMode: getRunMode,
    getApiBaseUrl: getApiBaseUrl,
    getAdIndexArray: getAdIndexArray,
    initSelectArray: initSelectArray,
    prepSelectArray: prepSelectArray,
    isApple: isApple,
    isAndroid: isAndroid,
    isMobile: isMobile,
    isDesktop: isDesktop,
    leadingWords: leadingWords,
    hasVivaCookie,
    setVivaCookie
}

module.exports = utils



// WEBPACK FOOTER //
// ./src/utils/utils.js